// extracted by mini-css-extract-plugin
export default {"highlight":"TranscriptionListRow_highlight__aZavw"};